import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import moment from "moment";
import QrScanner from "./QrScanner";
import { isSeatRealtimeEvent } from "./realtime";
import { jwtDecode } from "jwt-decode";

const STATE_LABEL = {
    booked: { text: 'Chờ kích hoạt', cls: 'text-warning' },
    active: { text: 'Đang sử dụng', cls: 'text-success' },
    completed: { text: 'Đã kết thúc', cls: 'text-muted' },
    expired: { text: 'Hết hạn (không quét QR)', cls: 'text-danger' },
    cancelled: { text: 'Đã hủy', cls: 'text-danger' },
};

const getSeatSortValue = (seat) => {
    const seatIndex = Number(seat.seat_index);
    if (!Number.isNaN(seatIndex)) return seatIndex;
    const codeNumber = String(seat.code || '').match(/\d+$/);
    if (codeNumber) return Number(codeNumber[0]);
    return Number(seat.id) || 0;
};

const sortSeatsLowToHigh = (list) => list.slice().sort((a, b) => getSeatSortValue(a) - getSeatSortValue(b));

const formatSeatSchedule = (booking) => {
    if (!booking || !booking.datestart) return '';
    return moment.unix(booking.datestart).format('DD/MM HH:mm');
};

const getCheckinDeadline = (booking) => Number(booking?.effective_checkin_deadline || booking?.checkin_deadline || 0);

// Màn đặt chỗ ngồi (giống đặt vé) + tích hợp kích hoạt QR ngay tại đây:
// - chọn chỗ trống -> đặt
// - chọn chỗ MÌNH đã đặt (chờ kích hoạt) -> hiện nút quét QR để check-in
export default function DatChoNgoi() {
    const { user } = useSelector((state) => state.auth);
    const { saveRealTimeData, datasocket } = useSelector((state) => state.save);
    const today = moment().format('YYYY-MM-DD');

    const [locations, setLocations] = useState([]);
    const [locationId, setLocationId] = useState('');
    const [date, setDate] = useState(today);

    const [seats, setSeats] = useState([]);
    const [bookings, setBookings] = useState([]);   // tất cả booking đang giữ chỗ tại địa điểm (mọi người)
    const [selectedSeat, setSelectedSeat] = useState(null);
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [showBookModal, setShowBookModal] = useState(false);
    const [bookingTimestart, setBookingTimestart] = useState('08:00');
    const [bookingTimeend, setBookingTimeend] = useState('12:00');

    const [showScan, setShowScan] = useState(false);
    const [scanResult, setScanResult] = useState(null);

    const [tab, setTab] = useState('book');     // 'book' | 'mine'
    const [myBookings, setMyBookings] = useState([]);
    const seatSocketRef = useRef(null);

    const myId = user.data.id;

    const fetchSeatBookings = () => {
        if (!locationId) return;
        Axios.get(URL_LIST_ALL + "seat_bookings?limit=1000&location_id=" + locationId + "&status=1&availability=1", user.config).then(res => {
            if (res.data.status === "success") setBookings(res.data.data);
        }).catch(err => console.log(err));
    };

    useEffect(function () {
        Axios.get(URL_LIST_ALL + "seat_locations?limit=1000&status=1", user.config).then(res => {
            if (res.data.status === "success") {
                const list = res.data.data.filter(l => l.status == 1);
                setLocations(list);
                if (list.length > 0) setLocationId(prev => prev || list[0].id);
            }
        }).catch(err => console.log(err));
    }, [user]);

    useEffect(function () {
        if (!locationId) { setSeats([]); setBookings([]); return; }
        Axios.get(URL_LIST_ALL + "seat_seats?limit=1000&location_id=" + locationId, user.config).then(res => {
            if (res.data.status === "success") setSeats(sortSeatsLowToHigh(res.data.data.filter(seat => Number(seat.status) !== 0)));
        }).catch(err => console.log(err));
        fetchSeatBookings();
        setSelectedSeat(null);
        setShowBookModal(false);
    }, [user, locationId, date, refresh]);

    useEffect(function () {
        if (!locationId) return;
        const intervalId = setInterval(fetchSeatBookings, 5000);
        return () => clearInterval(intervalId);
    }, [user, locationId]);

    // Danh sách booking của tôi (cho tab "Chỗ đã đặt của tôi")
    useEffect(function () {
        Axios.get(URL_LIST_ALL + "seat_bookings?limit=500", user.config).then(res => {
            if (res.data.status === "success") setMyBookings(res.data.data.filter(b => b.user_id == myId));
        }).catch(err => console.log(err));
    }, [user, refresh, myId]);

    useEffect(function () {
        if (isSeatRealtimeEvent(saveRealTimeData) || isSeatRealtimeEvent(datasocket)) {
            setRefresh(prev => !prev);
            setSelectedSeat(null);
            setShowBookModal(false);
        }
    }, [saveRealTimeData, datasocket]);

    useEffect(function () {
        let closed = false;
        const connectSeatSocket = () => {
            const ws = new WebSocket('wss://socket.bhsgroup.vn');
            seatSocketRef.current = ws;
            ws.onmessage = (evt) => {
                try {
                    const data = jwtDecode(evt.data);
                    if (data && data.channel === 'bhs_socket' && isSeatRealtimeEvent(data)) {
                        setRefresh(prev => !prev);
                        setSelectedSeat(null);
                        setShowBookModal(false);
                    }
                } catch (e) { /* ignore malformed socket payload */ }
            };
            ws.onclose = () => {
                if (!closed) setTimeout(connectSeatSocket, 1000);
            };
        };
        connectSeatSocket();
        return () => {
            closed = true;
            if (seatSocketRef.current) seatSocketRef.current.close();
        };
    }, []);

    const dayStartTs = moment(date, 'YYYY-MM-DD').startOf('day').unix();
    const dayEndTs = moment(date, 'YYYY-MM-DD').add(1, 'day').startOf('day').unix();
    const nowTs = moment().unix();
    const selectedLocation = locations.find(item => item.id == locationId);

    const bookingBlocksSeat = (booking) => {
        if (!booking || Number(booking.status) !== 1) return false;
        const checkinDeadline = getCheckinDeadline(booking);
        if (booking.booking_state === 'booked' && checkinDeadline > 0 && checkinDeadline < nowTs) return false;
        if (booking.booking_state === 'active' && Number(booking.dateend) > 0 && Number(booking.dateend) < nowTs) return false;
        return true;
    };

    // Booking đang chiếm chỗ tại chỗ đó trong ngày đang chọn
    const seatBookingInRange = (seatId) => bookings.find(b => b.seat_id == seatId && bookingBlocksSeat(b) && b.datestart < dayEndTs && b.dateend > dayStartTs);
    const nextBlockingBookingForSeat = (seatId) => bookings
        .filter(b => b.seat_id == seatId && bookingBlocksSeat(b))
        .sort((a, b) => Number(a.datestart) - Number(b.datestart))[0];
    const isManualBusyActive = (seat) => Number(seat.status) === 2 && (!seat.manual_busy_until || Number(seat.manual_busy_until) > nowTs);
    const isSeatBookable = (seat) => Number(seat.status) === 1 || (Number(seat.status) === 2 && Number(seat.manual_busy_until) > 0 && Number(seat.manual_busy_until) <= nowTs);

    // Trạng thái hiển thị của 1 chỗ theo ngày đang chọn
    const seatState = (seat) => {
        const b = seatBookingInRange(seat.id);
        if (b) {
            if (b.user_id == myId) return 'mine'; // mình đã đặt trong ngày này
            return 'busy';                        // người khác đặt theo booking
        }
        if (isManualBusyActive(seat)) return 'manual-busy';
        if (!isSeatBookable(seat)) return 'locked';
        return 'free';
    };

    // Chỉ đặt trong 1 ngày: dùng đúng ngày đang chọn ở lưới (date) cho cả bắt đầu và kết thúc.
    const bookingStartTs = moment(date + ' ' + bookingTimestart, 'YYYY-MM-DD HH:mm').unix();
    const bookingEndTs = moment(date + ' ' + bookingTimeend, 'YYYY-MM-DD HH:mm').unix();
    const validBookingTime = bookingEndTs > bookingStartTs && bookingStartTs >= nowTs;
    const selectedSeatBusyForBookingTime = selectedSeat
        ? bookings.find(b => b.seat_id == selectedSeat.id && bookingBlocksSeat(b) && b.datestart < bookingEndTs && b.dateend > bookingStartTs)
        : null;
    const canSubmitBooking = selectedSeat && isSeatBookable(selectedSeat) && validBookingTime && !selectedSeatBusyForBookingTime;

    const openBookModal = (seat) => {
        setSelectedSeat(seat);
        setBookingTimestart('08:00');
        setBookingTimeend('12:00');
        setTitle('');
        setShowBookModal(true);
    };

    const closeBookModal = () => {
        setShowBookModal(false);
        setSelectedSeat(null);
        setTitle('');
    };

    const handleBook = () => {
        if (!canSubmitBooking) return;
        const values = {
            seat_id: selectedSeat.id,
            datestart: date,
            timestart: bookingTimestart,
            dateend: date,
            timeend: bookingTimeend,
            title,
        };
        setLoading(true);
        Axios.post(URL_LIST_ALL + 'seat_bookings', values, user.config).then(res => {
            setLoading(false);
            if (res.data.status === "success") {
                setBookings(prev => prev.concat([{
                    id: res.data.id,
                    seat_id: selectedSeat.id,
                    location_id: selectedSeat.location_id,
                    user_id: myId,
                    datestart: bookingStartTs,
                    dateend: bookingEndTs,
                    checkin_deadline: bookingStartTs + Number(selectedLocation?.activation_minutes || 15) * 60,
                    status: 1,
                    booking_state: 'booked',
                    effective_checkin_deadline: bookingStartTs + Number(selectedLocation?.activation_minutes || 15) * 60,
                }]));
                confirmAlert({ title: 'Đặt chỗ thành công', message: 'Tới chỗ ngồi và quét mã QR để kích hoạt trong thời gian cho phép.', buttons: [{ label: 'OK' }] });
                setShowBookModal(false); setSelectedSeat(null); setTitle(''); setRefresh(prev => !prev);
            } else {
                confirmAlert({ title: 'Không đặt được', message: res.data.message, buttons: [{ label: 'OK' }] });
            }
        }).catch(err => { setLoading(false); console.log(err); });
    };

    const openScan = () => { setScanResult(null); setShowScan(true); };

    const handleScan = (token) => {
        setShowScan(false);
        Axios.post(URL_LIST_ALL + 'seat_checkin', { qr_token: token }, user.config).then(res => {
            setScanResult({ status: res.data.status, message: res.data.message });
            if (res.data.status === "success") setRefresh(!refresh);
        }).catch(() => setScanResult({ status: 'error', message: 'Lỗi kết nối, thử lại' }));
    };

    const cancelMyBooking = (b) => {
        confirmAlert({
            title: 'Huỷ đặt chỗ', message: 'Huỷ chỗ đã đặt này?',
            buttons: [
                { label: 'Huỷ chỗ', onClick: () => {
                    Axios.put(URL_LIST_ALL + 'seat_bookings/' + b.id, { booking_state: 'cancelled' }, user.config).then(res => {
                        if (res.data.status === "success") { setSelectedSeat(null); setRefresh(!refresh); }
                        else confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                    }).catch(err => console.log(err));
                }},
                { label: 'Đóng' },
            ],
        });
    };

    // Panel hiển thị khi chọn 1 chỗ
    const renderPanel = () => {
        if (!selectedSeat) return null;
        const state = seatState(selectedSeat);
        const myBk = seatBookingInRange(selectedSeat.id);

        if (state === 'mine' && myBk) {
            const checkinDeadline = getCheckinDeadline(myBk);
            const canCheckin = myBk.booking_state === 'booked' && myBk.datestart <= nowTs && nowTs <= checkinDeadline;
            const canCancel = myBk.booking_state === 'booked' && myBk.datestart > nowTs;
            return (
                <div className="mt-4 p-3" style={{ background: '#eef7ff', borderRadius: 8 }}>
                    <h5>{selectedSeat.code} {selectedSeat.title} — Bạn đã đặt chỗ này</h5>
                    <p className="mb-2">
                        Thời gian: {moment.unix(myBk.datestart).format('HH:mm DD/MM/YYYY')} - {moment.unix(myBk.dateend).format('HH:mm DD/MM/YYYY')}
                        {' · '}
                        Trạng thái: {myBk.booking_state === 'active' ? <span className="text-success">Đang sử dụng</span> : <span className="text-warning">Chờ kích hoạt</span>}
                    </p>
                    {myBk.booking_state === 'booked' && (
                        <>
                            <button type="button" className="btn btn-success" onClick={openScan} disabled={!canCheckin} title={canCheckin ? '' : 'Chỉ quét được trong thời gian kích hoạt tại chỗ'}>
                                <i className="fas fa-qrcode"></i> Quét QR để kích hoạt
                            </button>
                            {!canCheckin && <div><small className="text-muted">Đến chỗ ngồi trong khung giờ đã đặt để quét QR kích hoạt (trước {moment.unix(checkinDeadline).format('HH:mm')}).</small></div>}
                            {canCancel && <button type="button" className="btn btn-outline-danger ms-2 mt-2" onClick={() => cancelMyBooking(myBk)}>Huỷ chỗ này</button>}
                        </>
                    )}
                    {myBk.booking_state === 'active' && <div className="text-success">Chỗ đang được bạn sử dụng, không cần thao tác thêm.</div>}
                </div>
            );
        }

        return null;
    };

    return (
        <AkkhorLayout idrole="dat-cho-ngoi">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Coreworking</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button type="button" className={"nav-link " + (tab === 'book' ? 'active' : '')} onClick={() => setTab('book')}>Đặt chỗ</button>
                        </li>
                        <li className="nav-item">
                            <button type="button" className={"nav-link " + (tab === 'mine' ? 'active' : '')} onClick={() => setTab('mine')}>Chỗ đã đặt của tôi</button>
                        </li>
                    </ul>

                    {tab === 'book' && <>
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-4 form-group">
                            <label>Địa điểm</label>
                            <select className="form-select height32" value={locationId} onChange={(e) => setLocationId(e.target.value)}>
                                <option value="">-- Chọn địa điểm --</option>
                                {locations.map(l => <option key={l.id} value={l.id}>{l.title}</option>)}
                            </select>
                        </div>
                        <div className="col-12 col-sm-3 form-group">
                            <label>Ngày</label>
                            <input type="date" className="form-control height32" value={date} min={today} onChange={(e) => setDate(e.target.value)} />
                        </div>
                    </div>

                    <div className="mt-3">
                        <div className="mb-2">
                            <span className="badge bg-success">Trống</span>{' '}
                            <span className="badge bg-info">Bạn đã đặt</span>{' '}
                            <span className="badge bg-secondary">Đã có người đặt</span>{' '}
                            <span className="badge bg-warning text-dark">Có lịch đặt</span>{' '}
                            <span className="badge bg-primary">Đang chọn</span>
                        </div>
                        <div className="d-flex flex-wrap" style={{ gap: 10 }}>
                            {seats.length === 0 && <div className="text-muted">Chưa có chỗ ngồi đang hiển thị tại địa điểm này</div>}
                            {seats.map(seat => {
                                const state = seatState(seat);
                                const scheduledBooking = state === 'free' ? nextBlockingBookingForSeat(seat.id) : null;
                                const selected = selectedSeat && selectedSeat.id === seat.id;
                                const clickable = state === 'free' || state === 'mine';
                                let cls = 'btn ';
                                if (selected) cls += 'btn-primary';
                                else if (scheduledBooking) cls += 'btn-warning';
                                else if (state === 'free') cls += 'btn-success';
                                else if (state === 'mine') cls += 'btn-info';
                                else cls += 'btn-secondary disabled';
                                let label = 'Trống';
                                if (state === 'locked') label = 'Không khả dụng';
                                else if (state === 'busy') label = 'Đã có người đặt';
                                else if (state === 'manual-busy') label = 'Đã có người đặt';
                                else if (state === 'mine') label = 'Bạn đặt';
                                else if (scheduledBooking) label = scheduledBooking.user_id == myId ? 'Bạn có lịch' : 'Có lịch đặt';
                                return (
                                    <button key={seat.id} type="button" className={cls}
                                        style={{ width: 104, height: 86, whiteSpace: 'normal' }}
                                        disabled={!clickable}
                                        onClick={() => state === 'free' ? openBookModal(seat) : setSelectedSeat(seat)} title={seat.title}>
                                        <div style={{ fontWeight: 'bold' }}>{seat.code || ('#' + seat.id)}</div>
                                        <small>{label}</small>
                                        {scheduledBooking && <small className="d-block">{formatSeatSchedule(scheduledBooking)}</small>}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {renderPanel()}

                    {scanResult && (
                        <div className={"alert mt-3 " + (scanResult.status === 'success' ? 'alert-success' : 'alert-danger')}>
                            {scanResult.status === 'success' ? 'Kích hoạt thành công! ' : ''}{scanResult.message}
                        </div>
                    )}
                    </>}

                    {tab === 'mine' &&
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Địa điểm</th>
                                    <th>Chỗ ngồi</th>
                                    <th>Thời gian sử dụng</th>
                                    <th>Trạng thái</th>
                                    <th className="text-center">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {myBookings.length === 0 && <tr><td colSpan="6" className="text-center">Bạn chưa đặt chỗ nào</td></tr>}
                                {myBookings.map(b => {
                                    const st = STATE_LABEL[b.booking_state] || { text: b.booking_state, cls: '' };
                                    const canCancel = b.booking_state === 'booked' && (b.datestart * 1000) > Date.now();
                                    return (
                                        <tr key={b.id}>
                                            <td>{b.id}</td>
                                            <td>{b.location_title}</td>
                                            <td>{b.seat_code} {b.seat_title}</td>
                                            <td>{moment.unix(b.datestart).format('HH:mm DD/MM/YYYY')} - {moment.unix(b.dateend).format('HH:mm DD/MM/YYYY')}</td>
                                            <td className={st.cls}>{st.text}</td>
                                            <td className="text-center">
                                                {canCancel
                                                    ? <button type="button" className="btn btn-sm btn-danger" onClick={() => cancelMyBooking(b)}>Hủy</button>
                                                    : <span className="text-muted">-</span>}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>}
                </div>
            </div>

            {/* Modal quét QR check-in */}
            <Modal show={showScan} onHide={() => setShowScan(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Quét mã QR tại chỗ ngồi</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {showScan && <QrScanner readerId="dat-cho-reader" onScan={handleScan} onError={(m) => { setShowScan(false); setScanResult({ status: 'error', message: m }); }} />}
                    <small className="text-muted d-block mt-2">Hướng camera vào mã QR dán tại chỗ ngồi.</small>
                </Modal.Body>
            </Modal>

            {/* Modal đặt chỗ */}
            <Modal show={showBookModal} onHide={closeBookModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Đặt chỗ: {selectedSeat ? (selectedSeat.code || ('#' + selectedSeat.id)) : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSeat && (
                        <>
                            <div className="mb-3">
                                <div><strong>{selectedSeat.code}</strong> {selectedSeat.title}</div>
                                <small className="text-muted">Chỉ đặt được trong ngày {moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')}, không đặt xuyên qua ngày khác.</small>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-4 form-group">
                                    <label>Ngày</label>
                                    <input type="text" className="form-control height32" value={moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')} readOnly disabled />
                                </div>
                                <div className="col-6 col-sm-4 form-group">
                                    <label>Giờ bắt đầu</label>
                                    <input type="time" className="form-control height32" value={bookingTimestart} onChange={(e) => setBookingTimestart(e.target.value)} />
                                </div>
                                <div className="col-6 col-sm-4 form-group">
                                    <label>Giờ kết thúc</label>
                                    <input type="time" className="form-control height32" value={bookingTimeend} onChange={(e) => setBookingTimeend(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Ghi chú</label>
                                <input type="text" className="form-control height32" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="VD: Ngồi làm việc dự án" />
                            </div>
                            {!validBookingTime && bookingStartTs < nowTs && <div className="text-danger">Giờ bắt đầu không được ở trong quá khứ.</div>}
                            {!validBookingTime && bookingStartTs >= nowTs && <div className="text-danger">Giờ kết thúc phải sau giờ bắt đầu.</div>}
                            {selectedSeatBusyForBookingTime && (
                                <div className="text-danger">
                                    Chỗ này đã có người đặt trong khung {moment.unix(selectedSeatBusyForBookingTime.datestart).format('HH:mm DD/MM/YYYY')} - {moment.unix(selectedSeatBusyForBookingTime.dateend).format('HH:mm DD/MM/YYYY')}.
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={closeBookModal}>Đóng</button>
                    <button type="button" className="btn btn-success" disabled={loading || !canSubmitBooking} onClick={handleBook}>
                        {loading ? 'Đang đặt...' : 'Đặt chỗ này'}
                    </button>
                </Modal.Footer>
            </Modal>
        </AkkhorLayout>
    );
}
